import React from 'react';
import { Home, List, ShoppingCart, Bell, User } from 'lucide-react';
import './index.css';

const BottomNavigator = ({
    activeTab = 'home',
    onTabChange,
    cartCount = 0,
    notificationCount = 0,
    t // translation function if you're using i18n
}) => {
    const navigationItems = [
        {
            id: 'home',
            label: t ? t('Home') : 'Home',
            icon: Home,
            path: '/'
        },
        {
            id: 'categories',
            label: t ? t('Categories') : 'Categories',
            icon: List,
            path: '/search'
        },
        {
            id: 'cart',
            label: t ? t('Cart') : 'Cart',
            icon: ShoppingCart,
            path: '/viewPage',
            badge: cartCount
        },
        {
            id: 'notifications',
            label: t ? t('Notifications') : 'Notifications',
            icon: Bell,
            path: '/notifications',
            badge: notificationCount
        },
        {
            id: 'account',
            label: t ? t('Account') : 'Account',
            icon: User,
            path: '/account'
        }
    ];

    const handleTabClick = (item) => {
        if (onTabChange) {
            onTabChange(item.id, item.path);
        }
    };

    return (
        <div className="bottom-navigator">
            <div className="nav-container">
                {navigationItems.map((item) => {
                    const IconComponent = item.icon;
                    const isActive = activeTab === item.id;
                    const isCart = item.id === 'cart';

                    return (
                        <div key={item.id} className="nav-item">
                            <button
                                className={`nav-button ${isActive ? 'active' : ''}`}
                                onClick={() => handleTabClick(item)}
                                aria-label={item.label}
                            >
                                <div className="icon-wrapper">
                                    {isCart ? (
                                        <div className="cart-icon">
                                            <IconComponent className="nav-icon" />
                                            {item.badge > 0 && (
                                                <div className="badge cart-badge">
                                                    {item.badge > 99 ? '99+' : item.badge}
                                                </div>
                                            )}
                                        </div>
                                    ) : (
                                        <>
                                            <IconComponent className="nav-icon" />
                                            {item.badge > 0 && (
                                                <div className="badge">
                                                    {item.badge > 99 ? '99+' : item.badge}
                                                </div>
                                            )}
                                        </>
                                    )}
                                </div>

                                <div className="nav-label">
                                    {item.label}
                                </div>
                            </button>
                        </div>
                    );
                })}
            </div>
        </div>
    );
};

export default BottomNavigator;